import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Whale Succulent | Home',
  description: 'We sell the most beautiful succulents in Canada',
  keywords: 'succulents, soil, pots, plants',
};

export default Meta;
